import React from 'react';

import './DropLine.scss';

const DropLine = ({ visible = false }) => {
  return <div className={`drop-line ${visible ? '' : 'drop-line-hidden'} `} />;
};

export default DropLine;
